<router-outlet></router-outlet>
<div class="overlay" *ngIf="isLoading | async">
  <mat-progress-spinner class="spinner" [mode]="'indeterminate'" diameter="50" value='50'>
  </mat-progress-spinner>
</div>
